/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { PureComponent } from "react";
import firebase from "../../../config/firebase";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter
} from "reactstrap";
import BorderedTable from "../../../shared/components/table/BorderedTable";
import ViewCompanyPage from "../../ViewCompanyPage/components/viewCompany";
// import Pagination from "../../../shared/components/pagination/Pagination";
import {
  getAllCompanies,
  getMoreCompanies
} from "../../../redux/middlewares/Company/getCompany";
import { newsLetter } from "../../../redux/actions/jobsActions";
import Content from '../../Subcriptions/components/email_content'


export default class DataTable extends PureComponent {
  constructor() {
    super();
    this.heads = [
      {
        key: "SNo",
        name: "#",
        width: 80
      },
      {
        key: "id",
        name: "Id",
        width: 80
      },
     
      {
        key: "timestamp",
        name: "Timestamp",
        sortable: true
      },
      {
        key: "subscribers",
        name: "Subscribers",
        sortable: true
      },
      {
        key: "jobs",
        name: "Jobs",
        sortable: true
      },
      // {
      //   key: "view",
      //   name: "View",
      //   sortable: true
      // }

    ];

    const SubscriptionRef = firebase.firestore().collection("newsLetters");
    this.getnewsLetters = query =>
      SubscriptionRef
      // .orderBy("desc")
        .limit(query.limit)
        .get();

    this.getMorenewsLetters = query =>
      SubscriptionRef
      // .orderBy("Timestamp", "desc")
        .limit(query.limit)
        .startAfter(query.startAfter)
        .get();

    

    this.state = {
      rows: undefined,
      rowsPerPage: 10,
      page: 1,
      newsLetters: undefined,
      loading: true,
      initialLimit: 15,
      moreData: false,
      lastVisible: undefined,
      clickedCompany: undefined,
      isOpen: false
    };
  }

  componentDidMount() {
    this.getnewsLetters({ limit: this.state.initialLimit })
      .then(docs => {
        console.log(docs.size);
        if (!docs.empty) {
          const { rowsPerPage, page } = { ...this.state };
          let newsLetters = [];
          docs.forEach(doc =>{
           console.log(doc.data().data)
            newsLetters.push({ ...doc.data().data, id: doc.id })
          }
          );
          let moreData = newsLetters.length > this.state.rowsPerPage;
          // Checking for last data retrive
          let lastVisible = docs.docs[docs.docs.length - 1];
          this.setState({ newsLetters, moreData, lastVisible }, () =>
            this.createRows(rowsPerPage, page)
          );
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  onChangePage = pageToGo => {
    const { page, rowsPerPage, newsLetters } = this.state;
    // IF Data is Already avaliable direct render it.
    if (pageToGo < page || newsLetters.length > pageToGo * rowsPerPage) {
      this.setState({ page: pageToGo, moreData: true }, () =>
        this.createRows(rowsPerPage, pageToGo)
      );
    }
    // Else call from Database.
    else if (pageToGo > page) {
      this.callMoreData();
    }
  };

  callMoreData = () => {
    const { rowsPerPage, newsLetters, lastVisible, page } = this.state;
    if (lastVisible) {
      this.setState({ loading: true });
      this.getMorenewsLetters({
        limit: rowsPerPage,
        startAfter: lastVisible
      }).then(snap => {
        if (!snap.empty) {
          const newData = [];
          snap.forEach(docs => newData.push({ ...docs.data(), id: docs.id }));
          let allData = [...newsLetters, ...newData];
          //  Check if the entry is already available
          const uniqueData = Array.from(new Set(allData.map(a => a.id))).map(
            id => {
              return allData.find(a => a.id === id);
            }
          );
          // Checking for last data retrive
          let lastVisible = snap.docs[snap.docs.length - 1];
          let moreData = rowsPerPage * (page + 1) < uniqueData.length;
          this.setState({
            loading: false,
            newsLetters: uniqueData,
            lastVisible,
            moreData
          });
        } else {
          let moreData =
            newsLetters.length > (page + 1) * rowsPerPage ? true : false;
          this.setState({ moreData, page: page + 1 });
        }
        this.createRows(rowsPerPage, page + 1);
      });
    }
  };

  fromSecondsToDate = seconds => new Date(seconds * 1000).toLocaleDateString();

  // Make the arrangement Same As heads
  createRows = (rowsPerPage, page) => {
    const rows = [];
    // const that = this;
    const newsLetters = [...this.state.newsLetters];
    const start = rowsPerPage * (page - 1);
    const end =
      page === 1 && newsLetters.length > rowsPerPage
        ? rowsPerPage
        : newsLetters.length < start + rowsPerPage //rowsPerPage >= newsLetters.length ||
        ? newsLetters.length
        : rowsPerPage * page;

    // console.log({ newsLetters, start, end });
 console.log(newsLetters,end,start)
    try {
      for (let i = start; i < end; i++) {
        console.log(Array.isArray((newsLetters[i].jobs)),'date',i);

        rows.push({
          sno: i + 1,
          id: newsLetters[i].id,
          // email: newsLetters[i].email,
          timestamp: newsLetters[i].timeStamp
            ? this.fromSecondsToDate(newsLetters[i].timeStamp.seconds)
            : "",
          subscribers:newsLetters[i].subscribers?.length,
          jobs:newsLetters[i]  .jobs?.length,
        });
      }
    } catch (error) {
      console.error(error);
    }

    // setTimeout(() => {
    //   console.log(rows);
    // }, 300);

    this.setState({ rows, loading: false });
  };

  filterRows = (originalRows, pageNumber, rowsOnPage) => {
    const rowsFrom = rowsOnPage * (pageNumber - 1);
    const rowsTo = rowsFrom + rowsOnPage;
    return originalRows.slice(rowsFrom, rowsTo);
  };

  toggleModal = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  onRowClickHandler = id => {
    const filter = this.state.newsLetters.filter(e => e.id === id);
    if (filter.length > 0)
      this.setState({ clickedCompany: filter[0] }, this.toggleModal());
  };

  render() {
    const { rows, moreData, page, loading,isOpen,newsLetters } = this.state;
    console.log(rows);

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
            
            </div>
            <div
              style={{
                height: "400px",
                overflow: "auto",
                border: "1px solid #efefef  ",
                // display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {loading ? (
                <h3
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  Loading...
                </h3>
              ) : (
                rows && (
                  <BorderedTable
                    heads={this.heads}
                    rows={rows}
                    onRowClickHandler={this.onRowClickHandler}
                  />
                )
              )}
            </div>

            <Row style={{ margin: "1vw .2vw" }}>
              <Col sm={6}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={page === 1}
                  onClick={() => this.onChangePage(page - 1)}
                >
                  Prev
                </Button>
              </Col>
              <Col sm={6} style={{ textAlign: "end" }}>
                <Button
                  color="primary"
                  size="sm"
                  disabled={!moreData}
                  onClick={() => this.onChangePage(page + 1)}
                >
                  Next
                </Button>
              </Col>

              <Modal isOpen={isOpen} toggle={this.toggle} style={{maxWidth:'600px'}} >
                  <ModalHeader toggle={this.toggleModal}  >
                    <div style={{textAlign:'left'}} >
                      <p>News Letter Preview</p>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <Content
                      selected_newsLetter={newsLetters?.jobs}
                    />
                  </ModalBody>
                  <ModalFooter>                  
                    <Button
                      color="secondary"
                      onClick={this.toggleModal}
                      size="sm"
                      disabled={loading}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>

            </Row>
            {/* <Pagination
              itemsCount={rows.length}
              itemsToShow={itemsToShow}
              pageOfItems={pageOfItems}
              onChangePage={this.onChangePage}
            /> */}
          </CardBody>
        </Card>
      </Col>
    );
  }
}
